<template>
  <div class="big-box">
    <div class="scroll-box">
      <div>
        <div
          class="big-box-img"
          :style="{ 'background-image': `url(${bgUrl})` }"
        ></div>
        <div class="big-body">
          <img :src="tapTopUrl" alt="" class="tap-top" />
          <div class="theme" :style="{ color: customerPaperwork.titleColor }">
            {{ customerPaperwork.title }}
          </div>
          <div class="desc" :style="{ color: customerPaperwork.titleColor }">
            {{ customerPaperwork.desc  }}
          </div>

          <div
            style="
              width: 156px;
              height: 20px;
              font-size: 9px !important;
              color: #333333;
              margin-top: 23px;
              background-size: 100% 100%;
            "
            class="flex-cen-xy"
          >
            团长奖励，邀请{{
              ruleForm.inviteTeamNum ||
              ruleForm.prizeSettingListStep[0].inviteTeamNum
            }}人加入团队可得
          </div>

          <div
            class="prize-box-item flex-x"
            style="min-height: 193px; margin-bottom: 30px"
          >
            <div
              style="position: relative; height: fit-content"
              v-if="selectPrize.prizeType"
            >
              <img
                :src="selectPrize.prizeType!=1 ? selectPrize.logo : couponLogo"
                style="
                  width: 146px;
                  height: 146px;
                  margin-top: 8px;
                  border-radius: 8px;
                "
              />
              <div
                v-if="customerPaperwork.hideStock == 1"
                style="
                  font-size: 8px;
                  padding: 4px 6px;
                  background: rgba(0, 0, 0, 0.4);
                  border-radius: 8px 0px 8px 0px;
                  width: fit-content;
                  color: #ffffff;
                  position: absolute;
                  bottom: 3px;
                  right: 0;
                "
              >
                剩余{{ selectPrize.totalAmount }}份
              </div>
            </div>

            <div style="width: 100%; position: relative; min-height: 11px">
              <template v-if="selectPrize.title">
                <div
                  style="
                    font-size: 11px;
                    margin-top: 8px;
                    text-align: center;
                    color: #333333;
                  "
                  class="ellipsis_1"
                >
                  {{ selectPrize.title }}
                </div>
              </template>
            </div>
          </div>

          <div style="font-size: 8px; color: #ffffff; margin-bottom: 16px">
            活动距开始
            <span class="time-box">30</span>
            天
            <span class="time-box">23</span>: <span class="time-box">59</span>:
            <span class="time-box">59</span>
          </div>

          <div
            class="main-button"
            :style="{
              'background-image': `url(${customerPaperwork.btnBgUrl ? customerPaperwork.btnBgUrl : btnBgUrl})`,
              color: customerPaperwork.btnWordColor,
            }"
          >
            立即开团
          </div>

          <div
            :style="{
              backgroundImage: `url(${my_team_bg})`,
            }"
            style="
              width: 265px;
              height: 89px;
              background-size: 100% 100%;
              margin-bottom: 12px;
            "
            class="flex-x"
          >
            <img
              src="https://cdn-image.yucrm.cn/images/dyAssets/images/preview/avatar.png"
              style="
                width: 27px;
                height: 27px;
                border-radius: 50%;
                margin: 42px 2px 0 2px;
              "
            />
          </div>

          <div
            v-if="ruleForm.teamMemberTable[0].logo"
            style="
              width: 265px;
              height: 130px;
              background-size: 100% 100%;
              padding-top: 38px;
            "
            :style="{
              backgroundImage: `url(${team_member_bg})`,
            }"
            class="flexc-cen-y"
          >
            <img
              :src="ruleForm.teamMemberTable[0].prizeType!=1 ? ruleForm.teamMemberTable[0].logo : couponLogo"
              style="width: 78px; height: 78px; border-radius: 5px"
            />
            <div class="flex-father-box" style="margin: 6px 0 0 9px">
              <div
                style="
                  width: 145px;
                  font-weight: bold;
                  font-size: 11px;
                  color: #333333;
                "
              >
                {{ ruleForm.teamMemberTable[0].title }}
              </div>
              <div
                style="
                  font-size: 9px;
                  padding: 2px 6px;
                  border: 1px solid #e1e1e1;
                  border-radius: 2px;
                  width: fit-content;
                  color: #999999;
                  margin: 7px 0 20px 0;
                "
              >
                剩余{{ ruleForm.teamMemberTable[0].totalAmount }}份
              </div>
              <div style="color: #f8304b">
                <span style="font-size: 8px; margin-right: 2px">价值</span>
                <span style="font-size: 14px">{{
                  ruleForm.teamMemberTable[0].price
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="title" v-if="!oneShow">图为预览效果，以实际投效果为准</div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    oneShow: {
      type: Boolean,
      default: false,
    },
    baseUrl: {
      type: String,
      default: "",
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    btnBgUrl: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      couponLogo: "https://cdn-image.yucrm.cn/images/V24/popup_coupon.png",
      tapTopUrl: "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png",

      team_prize_title_bg: this.baseUrl + "team_prize_title_bg.png",
      my_team_bg: this.baseUrl + "my_team_bg.png",
      team_member_bg: this.baseUrl + "team_member_bg.png",
    };
  },
  computed: {
    selectPrize() {
      if (
        this.ruleForm.commanderPrizeType == 0 &&
        this.ruleForm.tableData.length > 0
      ) {
        return this.ruleForm.tableData[0];
      } else if (
        this.ruleForm.commanderPrizeType == 1 &&
        this.ruleForm.prizeSettingListStep[0].table.length > 0
      ) {
        return this.ruleForm.prizeSettingListStep[0].table[0];
      }
      return null;
    },
    bgUrl() {
      return this.ruleForm.cusTemplateJSON ? JSON.parse(this.ruleForm.cusTemplateJSON).activityBgImg : this.ruleForm.backgroundImage;
    }
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 1;
  background-color: #ffffff;
  // overflow: auto;
  // 隐藏滚动条

  .scroll-box {
    overflow: auto;
    height: 560px;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    -ms-overflow-style: none;
    border-radius: 24px;
  }

  // overflow: hidden;
  .big-box-img {
    border-radius: 24px;
    width: 283px;
    height: 755px;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .big-body {
    // position: absolute;
    // top: 0;
    // left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    // overflow: hidden;
    margin-top: -760px;

    .btn-box {
      width: 177px;
      height: 34px;
      position: relative;
      // position: absolute;
      // top: 480px;

      .btn-box-text {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 12px;
        font-weight: bold;
      }
    }

    .tap-top {
      margin-top: 8px;
    }
    .theme {
      font-weight: 600;
      font-size: 16px;
      margin-top: 14px;
      text-transform: none;
    }
    .desc {
      margin: 12px auto;
      // width: 170px;
      height: 10px;
      font-weight: 400;
      font-size: 11px;
      text-align: center;
      line-height: 10px;
      font-style: normal;
      text-transform: none;
    }
  }
  .more-activity {
    position: absolute;
    width: 60px;
    height: 60px;
    bottom: 125px;
    right: 6px;
  }
  .title {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
}
.main-button {
  width: 174px;
  height: 42px;
  font-size: 13px;
  background-size: cover;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 13px;
  font-weight: bold;
}
.time-box {
  color: #ffffff;
  border-radius: 2px;
  margin: 0 2px;
  background: rgba(255, 255, 255, 0.15);
  padding: 2px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}
.prize-box {
  padding: 6px;
  margin-top: 16px;
  display: flex;
  flex-direction: row;

  &-item {
    padding: 0 12px;
    // display: flex;
    // flex-direction: row;
    border-radius: 0 0 6px 6px;
  }
}
</style>
